// extracted by mini-css-extract-plugin
module.exports = {"generate-button":"TaggersReportRepositoryOverTime_generate-button__3yQs2","download-button":"TaggersReportRepositoryOverTime_download-button__2A3Sg"};